import React, { useState, useRef, memo } from "react";
// import { Badge } from "react-bootstrap";
import { getIconForItem } from "./IconMap";
import { Icon } from '@iconify/react';

const ShoppingItemTile = memo(({ item, onClick, onLongPress, color }) => {
  const iconname = getIconForItem(item.name);
  const description = item.propertiesDescription || item.properties;
  const timerRef = useRef(null);
  const touchStartRef = useRef({ x: 0, y: 0 });
  const touchHandledRef = useRef(false);

  const [isLongPress, setIsLongPress] = useState(false);
  const [isMoved, setIsMoved] = useState(false);

  const handleStart = (e) => {
    const touch = e.touches ? e.touches[0] : e;
    touchStartRef.current = { x: touch.clientX, y: touch.clientY };
    touchHandledRef.current = false;
    setIsMoved(false);
    setIsLongPress(false);

    timerRef.current = setTimeout(() => {
      setIsLongPress(true);
      touchHandledRef.current = true;
      if (onLongPress) onLongPress(item);
    }, 600);
  };

  const handleMove = (e) => {
    if (!touchStartRef.current) return;
    const touch = e.touches ? e.touches[0] : e;
    const deltaX = Math.abs(touch.clientX - touchStartRef.current.x);
    const deltaY = Math.abs(touch.clientY - touchStartRef.current.y);

    if (deltaX > 10 || deltaY > 10) {
      setIsMoved(true);
      if (timerRef.current) clearTimeout(timerRef.current);
    }
  };

  const handleEnd = () => {
    if (timerRef.current) clearTimeout(timerRef.current);
    if (!isMoved && !isLongPress && onClick && !touchHandledRef.current) {
      touchHandledRef.current = true;
      onClick(item);
    }
    setIsMoved(false);
  };

  /* REMOVED: Dynamic sizing logic as we now use CSS clamp */


  return (
    <div
      onMouseDown={handleStart}
      onMouseUp={handleEnd}
      onTouchStart={handleStart}
      onTouchMove={handleMove}
      onTouchEnd={handleEnd}
      onClick={(e) => e.preventDefault()}
      className={`shopping-item-tile shadow-sm position-relative user-select-none`}
      style={{
        borderTop: `4px solid ${color}`,
        transform: isLongPress ? 'scale(0.98)' : 'scale(1)',
      }}
    >
      {item.quantity > 0 && (item.quantity !== 1 || item.unit) && (
        <div className="item-badge">
          {item.quantity}{item.unit ? ` ${item.unit}` : ''}
        </div>
      )}

      <div className="item-content">
        <div className="item-icon-wrapper">
          {(iconname && (iconname.includes('/') || /\.(png|jpg|jpeg|webp|svg)$/.test(iconname))) ? (
            <img src={iconname} alt="" />
          ) : (
            <Icon icon={iconname} style={{ color: color }} />
          )}
        </div>
        <div className="item-text-container">
          <div className="item-name">{item.name.charAt(0).toUpperCase() + item.name.slice(1)}</div>
          {description && <div className="item-desc">{description}</div>}
        </div>
      </div>

      {item.mealPlanNote && (
        <div className="recipe-tag">
          {item.mealPlanNote}
        </div>
      )}
    </div>
  );
});

export default ShoppingItemTile;